<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <v-card>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="black"
            grow
          >
            <v-tab
              v-for="item in items"
              :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="item in items"
              :key="item"
            >
              <v-card flat>
                <v-simple-table fixed-header class="py-0" height="570">
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-center" style="text-transform: uppercase">Ficha</th>
                      <th class="text-center" style="text-transform: uppercase">Natureza</th>
                      <th class="text-center" style="text-transform: uppercase">Status</th>
                      <th class="text-center" style="text-transform: uppercase">Veículo</th>
                      <th class="text-center" style="text-transform: uppercase">Tempo</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in desserts" :key="index">
                      <td class="text-center">{{ item.number }}</td>
                      <td class="text-center">{{ item.nature }}</td>
                      <td class="text-center">
                        <v-chip label small>{{ item.status }}</v-chip>
                      </td>
                      <td class="text-center">{{ item.vehicle }}</td>
                      <td class="text-center">{{ item.datetime }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title class="headline font-weight-medium teal--text text--accent-3">
            <v-spacer/>
            Atendimento
            <v-spacer/>
          </v-card-title>
          <v-progress-linear  class="justify-center align-center" color="#1de9b6" height="5"/>
          <v-card-text>
            <v-col cols="6">
              <strong>Paciente:</strong>
              <span></span>
            </v-col>
            <v-col cols="6">
              <strong>Endereço:</strong>
              <span></span>
            </v-col>
            <v-col cols="6">
            <v-select
              :items="items"
              label="Base"
              outlined
              dense
              hide-details
            />
            </v-col>
            <v-col cols="6">
            <v-select
              :items="items"
              label="Veículo"
              outlined
              dense
              hide-details
            />
            </v-col>
            <v-col cols="12">
              <strong>Risco Comprovado</strong>
            </v-col>
            <v-col cols="12">
                <v-radio-group
                  height="50"
                  v-model="classification"
                  :rules="classificationRules"
                  class="mt-0 mb-1 py-0 px-0 primary--text"
                  :column="$vuetify.breakpoint.name === 'xs'?true:false">
                  <v-radio
                    class="blue--text"
                    value="emergencia">
                    <template v-slot:label>
                      <div class="primary--text">
                        Emergência
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="muito-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Muito Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="pouco-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Pouco Urgente
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    class="primary--text"
                    value="nao-urgente">
                    <template v-slot:label>
                      <div class="primary--text">
                        Não Urgente
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-progress-linear
                  v-if="corClassification"
                  :style="classification !== '' ? 'visibility: visible;':'visibility: hidden;'"
                  class="my-3"
                  v-model="valueDeterminate"
                  :color="corClassification"
                  height="15">
                </v-progress-linear>
            </v-col>
            <v-card class="elevation-0 my-0">

              <v-card-title class="subtitle-1 py-0">
                <strong>Tipo de veículo</strong>
<!--                <span  v-if="errorFormVehicle" class="red&#45;&#45;text ml-8">É necessário escolher um veículo!</span>-->
              </v-card-title>

              <v-card-text
                class="py-0"
                style="background-color:transparent;">
                  <v-item-group
                    v-model="vehicle"
                    active-class="indigo">
                    <v-row>
                      <v-col
                        v-for="n in v"
                        :key="n.name"
                        cols="2">
                        <v-item
                          :value="n"
                          v-slot:default="{ active, toggle }">
                          <v-card
                            class="d-flex align-center"
                            outlined
                            style="border-color: indigo; border-width:1px"
                            height="45"
                            @click="toggle">
                            <v-scroll-y-transition>

                              <div
                                v-if="active"
                                class="flex-grow-1 text-center indigo--text">
                                <v-btn text>
                              <span class="white--text">
                                {{n.name}}
                              </span>
                                  <v-icon color="white" large>
                                    {{n.icon}}
                                  </v-icon>
                                </v-btn>
                              </div>

                              <div
                                v-else
                                class="flex-grow-1 text-center indigo--text">
                                <v-btn text>
                              <span>
                                {{n.name}}
                              </span>
                                  <v-icon class="ml-1" large>
                                    {{n.icon}}
                                  </v-icon>
                                </v-btn>
                              </div>
                            </v-scroll-y-transition>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-row>
                  </v-item-group>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="primary" @click="dialog = false">
              Enviar
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: "FleetManager",
  data(){
    return {
      tab: null,
      corClassification: "",
      classification: "",
      valueDeterminate: 100,
      classificationRules: [
        (v) => !!v || "É necessário definir a classificação de risco da vítima!",
      ],
      //UBS - MOT - USA - VIR - LANCHA
      v: [
        { name: "USA", icon: "fas fa-ambulance" },
        { name: "VIR", icon: "airport_shuttle" },
        { name: "USB", icon: "fas fa-ambulance" },
        //{ name: "HEL", icon: "fa fa-helicopter" },
        { name: "MOT", icon: "fa fa-motorcycle" },
        { name: "LAN", icon: "directions_boat" },
        //{ name: "VTI", icon: "fas fa-truck" },
      ],
      vehicle: undefined,
      items: ['ocorrencias recebidas', 'ocorrencias enviadas', 'ocorrencias finalizadas'],
      desserts: [
        {
          number: 84,
          nature: 'Trauma',
          status: 'Andamento',
          vehicle: 'Sigla - Placa',
          datetime: '0 Dias, 0H, 25 min'
        },
        {
          number: 86,
          nature: 'Clinico',
          status: 'Andamento',
          vehicle: 'Sigla - Placa',
          datetime: '0 Dias, 0H, 15 Min'
        },
      ],
    }
  },
  mounted() {
    //
  },
  watch:{
    classification(value) {
      //this.fixaSelected.proven_risk = value;
      if (value === "emergencia") this.corClassification = "red";
      else if (value === "muito-urgente") this.corClassification = "orange";
      else if (value === "urgente") this.corClassification = "amber";
      else if (value === "pouco-urgente") this.corClassification = "green";
      else this.corClassification = "blue";
    }
  },
  computed:{
    //
  },
  methods:{
    //
  },
}
</script>
<style scoped></style>
